import { ISkill } from "../interfaces/skill";

const createNewSkill = (): ISkill => {
    return { id: "", name: "" }
}

export { createNewSkill };
